<script>

  export default {
    props: {
      message: {
        type: String,
        required: true,
      },
      gradientColourClasses: {
        type: String,
        default: 'tw-from-red-400 tw-to-orange-500',
      },
    },
    data() {
      return {
      }
    },
    computed: {
      messageSegments(){
        return this.message.split('\\n')
      }
    },
    methods: {
      confirm(){
        this.$customModal.hide(this.id)
        this.$emit('reloadModalConfirmed')
      }
    },
  }
</script>

<template>
  <section
    class="tw-flex tw-font-semibold tw-h-20 md:tw-h-10 tw-items-center tw-justify-center bg-blend-color	tw--mt-px tw-bg-gradient-to-b md:tw-bg-gradient-to-r"
    :class="[gradientColourClasses]">
    <span class="md:tw-px-2 tw-px-5  tw-text-black">{{message}}</span>
  </section>
</template>
